import {
    GETUSERWITHDRAWLIMITLIST_SUCCESS,
    GETUSERWITHDRAWLIMITLIST_FAILED,
    RESET_GETUSERWITHDRAWLIMITLIST,
    LOADING_GETUSERWITHDRAWLIMITLIST,
    NETWORK_ERROR_GETUSERWITHDRAWLIMITLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetUserWithdrawLimitList = () => {
    return { type: RESET_GETUSERWITHDRAWLIMITLIST };
};

const getUserWithdrawLimitList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETUSERWITHDRAWLIMITLIST });
    await partnerServices
        .post("getUserWithDrawLimitList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getUserWithdrawLimitListsuccess(res.data));
                    break;
                default:
                    dispatch(getUserWithdrawLimitListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETUSERWITHDRAWLIMITLIST, payload: err });
        });
};
function getUserWithdrawLimitListsuccess(data) {
    return {
        type: GETUSERWITHDRAWLIMITLIST_SUCCESS,
        payload: data,
    };
}
function getUserWithdrawLimitListFailed(data) {
    return {
        type: GETUSERWITHDRAWLIMITLIST_FAILED,
        payload: data,
    };
}

export { resetGetUserWithdrawLimitList, getUserWithdrawLimitList };
